import * as React from "react";

export const useMutationObserver = (
  callback: MutationCallback,
  options?: MutationObserverInit,
  target: Node = document.body
) => {
  React.useEffect(() => {
    const observer = new MutationObserver(callback);
    const config = Object.assign({ childList: true, subtree: true }, options);

    observer.observe(target, config);

    return () => {
      observer.disconnect();
    };
  }, []);
};
